export default {"src":"/_next/static/media/list.e9c21ffb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};